import { Img, Text, Heading } from "../../components";
import { AuthContext } from "components/Context/AuthContext";
import SignInForm from "../../components/SignInForm";
import { useContext } from "react";
import React from "react";

export default function HomePageSection() {
  const { isAuthenticated } = useContext(AuthContext);
  return (
    <>
      {/* home page section */}
      <div className="flex justify-center self-stretch">
        <div className="container-xs flex items-center justify-center md:flex-col md:px-5">
          <div className="flex flex-1 flex-col items-start gap-[26px] md:self-stretch ">
            <Heading
              size="headinglg"
              as="h1"
              className="text-[96px] font-extrabold leading-[100px] tracking-[-1.92px] text-black-900_01 md:text-[48px] "
            >
              <>
                Tail
                <br />
                Risk
                <br />
                Global.
              </>
            </Heading>
            <Heading
              as="h2"
              className="w-[50%] text-[20px] font-medium leading-6 tracking-[-0.40px] text-black-900_01 md:w-full "
            >
              Revolutionizing Portfolio Risk Management. Proprietary methodology for illiquid assets and on-the-fly
              portfolio rebalancing.
            </Heading>
            <div className="flex items-end gap-[22px] bg-gray-900_01">
              <Text as="p" className="mt-1.5 text-[14px] font-medium tracking-[-0.28px] text-gray-400">
                Powered by
              </Text>
              <Img src="images/img_settings.svg" alt="Settings Image" className="h-[16px] w-[46%] object-contain" />
            </div>
          </div>
          {(!isAuthenticated)? <SignInForm /> : <></> }  

        </div>
      </div>
    </>
  );
}
